<template>
	<v-card rounded="xl" dark color="#363636">
		<v-card-title>
			<span style="font-size: 14px" class="d-flex justify-center">
				<v-icon medium>mdi-calendar-month</v-icon>
				<span class="ml-2">Appointment Calendar &nbsp; &nbsp;</span>
				<v-icon @click="listAppointment" color="green">mdi-refresh-circle</v-icon>
			</span>
			<v-spacer></v-spacer>
			<v-btn
				color="#3b5a5f"
				style="text-transform: none; margin: 5px 10px 5px 0px"
				rounded
				width="160"
				@click="toProfile"
				>Edit Availability</v-btn
			>
			<v-btn color="orange darken-3" style="text-transform: none; margin: 5px 10px 5px 0px" rounded width="160" @click="showNewAppointment"
				>New Appointment</v-btn
			>
			<v-icon @click="extData.showDialog = false">mdi-close-circle-outline</v-icon>
		</v-card-title>
		<v-expansion-panels v-model="panelCalendar" accordion>
			<v-expansion-panel v-for="(event, index) of eventList" :key="index">
				<v-expansion-panel-header>{{ event.day }}</v-expansion-panel-header>
				<v-expansion-panel-content color="#363636" style="height: 405px; overflow: auto">
					<div style="margin: 30px 40px">
						<div v-for="(hour, idxHour) of event.hourList" :key="idxHour" style="border-bottom: 1px solid grey; margin-bottom: 10px">
							<v-row>
								<v-col cols="12" sm="2">
									{{ (hour.id >= 7 && 12 > hour.id && hour.id != 11.3 ? hour.rangeName + "am " : hour.rangeName + "pm ") + experience.transitMap.timezoneName}}
								</v-col>
								<v-col cols="12" sm="10" v-if="hour.appointment" style="padding: 0px">
									<div
										style="padding: 2px 10px; border-radius: 15px; margin: 1px 0px; display: flex"
										:style="{
											backgroundColor: hour.appointment.isInvite ? '#388E3C' : '#FAFAFA',
											color: hour.appointment.isInvite ? 'white' : '#757575'
										}"
									>
										<v-row>
											<v-col cols="12" sm="3" style="padding: 5px 0px 5px 10px">
												<a @click="showAppointmentDetail(hour.appointment.id)">
													<span
														style="font-weight: bold; margin-right: 10px"
														:style="{
															color: hour.appointment.isInvite ? 'white' : '#757575'
														}"
													>
														{{ hour.appointment.title + "  " }}</span
													>
												</a>
											</v-col>
											<v-col cols="12" sm="4" style="padding: 5px 0px 5px 10px">
												{{ "   " + hour.appointment.attendees }}
											</v-col>
											<v-col cols="12" sm="3" style="padding: 5px 0px 5px 10px">
												{{hour.appointment.transitMap.status}}
											</v-col>
											<v-col cols="12" sm="2" style="padding: 5px 0px 5px 10px">
												<a
													:style="{
														color: hour.appointment.isInvite ? 'white' : '#757575'
													}"
													@click="openConversation(hour.appointment, event.day)"
												>
													<span> Join Conversation </span>
												</a>
											</v-col>
										</v-row>
									</div>
								</v-col>
							</v-row>
						</div>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<v-dialog v-model="showNewAppointmentDialog" content-class="col-sm-8 col-12 hide-box-shadow" persistent>
			<v-card rounded="xl">
				<v-form v-model="valid">
					<v-card-title>
						<span style="font-size: 14px" class="d-flex justify-center">
							<v-icon medium>mdi-calendar-month</v-icon>
							<span class="ml-2">New Meeting</span>
						</span>
						<v-spacer></v-spacer>
						<v-btn style="text-transform: none; margin: 5px 10px 5px 0px" rounded width="160" @click="showNewAppointmentDialog = false"
							>Cancel</v-btn
						>
						<v-btn
							color="orange darken-3"
							style="text-transform: none; margin: 5px 10px 5px 0px; color: white"
							rounded
							width="160"
							@click="sendInvites"
							:disabled="!valid || meeting.attendeeList.length == 0 || externalMeetingLinkStatus == 1"
							>Send Invites</v-btn
						>
					</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" sm="4">
								<v-select
									:items="eventList"
									v-model="meeting.date"
									item-text="day"
									label="Date"
									:rules="[(v) => !!v || 'Date is required']"
									@change="setStartTime(false)"
									:disabled="meeting.attendeeList.length > 0"
									dense
									rounded
									filled
									hide-details
									required
								/>
							</v-col>
							<v-col cols="12" sm="4">
								<v-select
									:items="startTime"
									v-model="meeting.startTime"
									label="Start Time"
									:rules="[(v) => !!v || 'Start Time is required']"
									@change="setEndTime(false)"
									:disabled="meeting.attendeeList.length > 0"
									dense
									rounded
									filled
									hide-details
									required
								>
									<template slot="item" slot-scope="data">
										<v-row>
											<v-col cols="1">
												<span style="font-size: 12px">{{ data.item.text }}</span>
												<hr v-if="data.item.disabled" style="width: 75px; position: absolute; margin-top: -11px" />
											</v-col>
											<v-col cols="2" v-if="data.item.disabled">
												<span style="margin-left: 50px; font-size: 12px">Unavailable</span>
											</v-col>
										</v-row>
									</template>
								</v-select>
							</v-col>
							<v-col cols="12" sm="4">
								<v-select
									:items="endTime"
									v-model="meeting.endTime"
									label="End Time"
									:rules="[(v) => !!v || 'End Time is required']"
									:disabled="meeting.attendeeList.length > 0"
									dense
									rounded
									filled
									hide-details
									required
								>
									<template slot="item" slot-scope="data">
										<v-row>
											<v-col cols="1">
												<span style="font-size: 12px">{{ data.item.text }}</span>
												<hr v-if="data.item.disabled" style="width: 75px; position: absolute; margin-top: -11px" />
											</v-col>
											<v-col cols="2" v-if="data.item.disabled">
												<span style="margin-left: 50px; font-size: 12px">Unavailable</span>
											</v-col>
										</v-row>
									</template>
								</v-select>
							</v-col>
							<v-col cols="12" sm="10">
								<v-autocomplete
									v-model="meeting.tmpAttendee"
									:items="experienceUserList"
									item-text="name"
									item-value="id"
									filled
									chips
									color="blue-grey lighten-2"
									label="Search Attendees"
									prepend-inner-icon="mdi-magnify"
									multiple
									dense
									rounded
									hide-details=""
									@focus="listAttendee"
								>
									<template v-slot:selection="data">
										<v-chip v-bind="data.attrs" :input-value="data.selected" @click="data.select">
											<v-avatar left>
												<v-img
													sizes="150"
													v-if="data.item.image && data.item.image.startsWith('data')"
													:src="data.item.image"
												></v-img>
												<v-img
													sizes="150"
													v-else-if="data.item.image && data.item.image !== 'undefined'"
													:src="baseLocation + '/asset/file/user/' + data.item.image"
												></v-img>
												<v-icon v-else>mdi-account-circle</v-icon>
											</v-avatar>
											{{ data.item.name }}
										</v-chip>
									</template>
									<template v-slot:item="data">
										<template>
											<v-list-item-avatar>
												<v-img
													sizes="150"
													v-if="data.item.image && data.item.image.startsWith('data')"
													:src="data.item.image"
												></v-img>
												<v-img
													sizes="150"
													v-else-if="data.item.image && data.item.image !== 'undefined'"
													:src="baseLocation + '/asset/file/user/' + data.item.image"
												></v-img>
												<v-icon v-else>mdi-account-circle</v-icon>
											</v-list-item-avatar>
											<v-list-item-content>
												<v-list-item-title v-html="data.item.name"></v-list-item-title>
												<v-list-item-subtitle v-html="data.item.status"></v-list-item-subtitle>
											</v-list-item-content>
										</template>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" sm="2">
								<v-btn
									color="#3b5a5f"
									style="color: white"
									rounded
									width="100%"
									height="100%"
									:disabled="!meeting.tmpAttendee || meeting.tmpAttendee.length === 0"
									@click="inviteAttendess"
									>Select</v-btn
								>
							</v-col>
							<v-col cols="12" sm="12" v-if="this.meeting.attendeeList && this.meeting.attendeeList.length > 0">
								<v-row
									style="
										border-top: 1px solid #d4cccc;
										border-bottom: 1px solid #d4cccc;
										padding-left: 35px;
										margin: 0px 10px;
										max-height: 170px;
										overflow: auto;
									"
								>
									<v-col cols="12" sm="4" v-for="(attendee, idxAttendee) of meeting.attendeeList" :key="idxAttendee">
										<v-avatar left size="30">
											<v-img
												sizes="25"
												v-if="attendee.image && attendee.image.startsWith('data')"
												:src="attendee.image"
											></v-img>
											<v-img
												sizes="25"
												v-else-if="attendee.image && attendee.image !== 'undefined'"
												:src="baseLocation + '/asset/file/user/' + attendee.image"
											></v-img>
											<v-icon v-else x-large>mdi-account-circle</v-icon>
										</v-avatar>
										<span style="font-weight: bold">{{ " " + attendee.name }}</span
										>{{ " " + attendee.status }}
										<v-icon @click="removeAttendee(idxAttendee)" color="red">mdi-close-circle</v-icon>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="12">
								<v-text-field
									v-model="meeting.title"
									label="Meeting Title*"
									:rules="[(v) => !!v || 'Meeting Title is required']"
									dense
									rounded
									filled
									hide-details=""
									required
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="12">
								<v-textarea
									v-model="meeting.message"
									label="Message*"
									:rules="[(v) => !!v || 'Message is required']"
									dense
									rounded
									filled
									hide-details=""
									required
								></v-textarea>
							</v-col>
							<v-col cols="12" sm="12" class="d-flex justify-center">
								<v-text-field
									v-model="meeting.extMeetingLink"
									label="External Meeting Link (Ex. Zoom, Teams)"
									:rules="externalMeetingLinkRules"
									ref="externalMeetingLink"
									dense
									rounded
									filled
									required
									@blur="ping(meeting.extMeetingLink)"
									@focus="externalMeetingLinkStatus = 1"
								></v-text-field>
							</v-col>
							<v-col v-if="meeting.extMeetingLink && meeting.extMeetingLink.length > 20" cols="12" class="py-0">
								<sup class="ml-2">
									<v-icon
									small
									color="grey darken-2"
										>
										mdi-information
									</v-icon>
									As we are not able to validate the meeting link, make sure you specified the correct meeting link.
								</sup>
							</v-col>
						</v-row>
					</v-card-text>
				</v-form>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showAppointmentDetailDialog" content-class="col-sm-8 col-12 hide-box-shadow" persistent>
			<v-card rounded="xl">
				<v-form v-model="valid">
					<v-card-title>
						<span style="font-size: 14px" class="d-flex justify-center">
							<v-icon medium>mdi-calendar-month</v-icon>
							<h3 style="margin-left: 10px">{{ meeting.title }}</h3>
							<span style="margin-left: 10px">({{ organizerName }} - organizer)</span>
						</span>
						<v-spacer></v-spacer>
						<v-btn style="text-transform: none; margin: 5px 10px 5px 0px" rounded width="160" @click="showAppointmentDetailDialog = false"
							>Cancel</v-btn
						>
						<v-btn
							v-if="meeting.isInvite"
							color="#3b5a5f"
							style="text-transform: none; margin: 5px 10px 5px 0px; color: white"
							rounded
							width="160"
							@click="resendInvitation"
							:disabled="!valid || meeting.attendeeList.length == 0 || isChangeDetail"
							>Resend Invitation</v-btn
						>
						<v-btn
							v-if="meeting.isInvite"
							color="#3b5a5f"
							style="text-transform: none; margin: 5px 10px 5px 0px; color: white"
							rounded
							width="160"
							@click="editMeeting"
							:disabled="!valid || meeting.attendeeList.length == 0 || externalMeetingLinkStatus == 1 || !isChangeDetail"
							>Save Changes</v-btn
						>
						<v-btn
							color="orange darken-3"
							style="text-transform: none; margin: 5px 10px 5px 0px; color: white"
							@click="cancelMeeting(meeting.dataMap.publicId, meeting.userPublicId, meeting.id, meeting.isInvite)"
							rounded
							width="160"
							>Cancel Meeting</v-btn
						>
					</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" sm="4">
								<v-select
									:items="eventList"
									v-model="meeting.date"
									item-text="day"
									label="Date"
									@change="setStartTime(true)"
									:disabled="!meeting.isInvite || meeting.attendeeList.length > 0"
									dense
									rounded
									filled
									hide-details
									required
								/>
							</v-col>
							<v-col cols="12" sm="4">
								<v-select
									:items="startTime"
									v-model="meeting.startTime"
									label="Start Time"
									@change="setEndTime(true)"
									:disabled="!meeting.isInvite || meeting.attendeeList.length > 0"
									dense
									rounded
									filled
									hide-details
									required
								>
									<template slot="item" slot-scope="data">
										<v-row>
											<v-col cols="1">
												<span style="font-size: 12px">{{ data.item.text }}</span>
												<hr v-if="data.item.disabled" style="width: 75px; position: absolute; margin-top: -11px" />
											</v-col>
											<v-col cols="2" v-if="data.item.disabled">
												<span style="margin-left: 50px; font-size: 12px">Unavailable</span>
											</v-col>
										</v-row>
									</template>
								</v-select>
							</v-col>
							<v-col cols="12" sm="4">
								<v-select
									:items="endTime"
									v-model="meeting.endTime"
									label="End Time"
									:disabled="!meeting.isInvite || meeting.attendeeList.length > 0"
									dense
									rounded
									filled
									hide-details
									required
								>
									<template slot="item" slot-scope="data">
										<v-row>
											<v-col cols="1">
												<span style="font-size: 12px">{{ data.item.text }}</span>
												<hr v-if="data.item.disabled" style="width: 75px; position: absolute; margin-top: -11px" />
											</v-col>
											<v-col cols="2" v-if="data.item.disabled">
												<span style="margin-left: 50px; font-size: 12px">Unavailable</span>
											</v-col>
										</v-row>
									</template>
								</v-select>
							</v-col>
							<v-col cols="12" sm="10">
								<v-autocomplete
									v-model="meeting.tmpAttendee"
									:items="experienceUserList"
									item-text="name"
									item-value="id"
									filled
									chips
									color="blue-grey lighten-2"
									label="Search Attendees"
									prepend-inner-icon="mdi-magnify"
									multiple
									dense
									rounded
									hide-details=""
									@change="changeAttendee"
									@focus="listAttendee"
									:disabled="!meeting.isInvite"
								>
									<template v-slot:selection="data">
										<v-chip v-bind="data.attrs" :input-value="data.selected" @click="data.select">
											<v-avatar left>
												<v-img
													sizes="150"
													v-if="data.item.image && data.item.image.startsWith('data')"
													:src="data.item.image"
												></v-img>
												<v-img
													sizes="150"
													v-else-if="data.item.image && data.item.image !== 'undefined'"
													:src="baseLocation + '/asset/file/user/' + data.item.image"
												></v-img>
												<v-icon v-else>mdi-account-circle</v-icon>
											</v-avatar>
											{{ data.item.name }}
										</v-chip>
									</template>
									<template v-slot:item="data">
										<template>
											<v-list-item-avatar>
												<v-img
													sizes="150"
													v-if="data.item.image && data.item.image.startsWith('data')"
													:src="data.item.image"
												></v-img>
												<v-img
													sizes="150"
													v-else-if="data.item.image && data.item.image !== 'undefined'"
													:src="baseLocation + '/asset/file/user/' + data.item.image"
												></v-img>
												<v-icon v-else>mdi-account-circle</v-icon>
											</v-list-item-avatar>
											<v-list-item-content>
												<v-list-item-title v-html="data.item.name"></v-list-item-title>
												<v-list-item-subtitle v-html="data.item.status"></v-list-item-subtitle>
											</v-list-item-content>
										</template>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" sm="2">
								<v-btn
									color="#3b5a5f"
									style="color: white"
									rounded
									width="100%"
									height="100%"
									:disabled="!isAnyAttendee"
									@click="inviteAttendess"
									>Select</v-btn
								>
							</v-col>
							<v-col cols="12" sm="12" v-if="this.meeting.attendeeList && meeting.attendeeList.length > 0">
								<v-row
									style="
										border-top: 1px solid #d4cccc;
										border-bottom: 1px solid #d4cccc;
										padding-left: 35px;
										margin: 0px 10px;
										max-height: 170px;
										overflow: auto;
									"
								>
									<v-col cols="12" sm="4" v-for="(attendee, idxAttendee) of meeting.attendeeList" :key="idxAttendee">
										<v-avatar left size="30">
											<v-img
												sizes="25"
												v-if="attendee.image && attendee.image.startsWith('data')"
												:src="attendee.image"
											></v-img>
											<v-img
												sizes="25"
												v-else-if="attendee.image && attendee.image !== 'undefined'"
												:src="baseLocation + '/asset/file/user/' + attendee.image"
											></v-img>
											<v-icon v-else x-large>mdi-account-circle</v-icon>
										</v-avatar>
										<span style="font-weight: bold">{{ " " + attendee.name }}</span
										>{{ " " + attendee.status }}
										<v-icon v-if="meeting.isInvite" @click="removeAttendee(idxAttendee)" color="red">mdi-close-circle</v-icon>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" sm="12">
								<v-text-field
									v-model="meeting.title"
									label="Meeting Title"
									:rules="[(v) => !!v || 'Meeting Title is required']"
									:disabled="!meeting.isInvite"
									dense
									rounded
									filled
									hide-details
									required
									@blur="checkChangeDetail"
									@focus="isChangeDetail = true"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="12">
								<v-textarea
									v-model="meeting.message"
									label="Message"
									:rules="[(v) => !!v || 'Message is required']"
									:disabled="!meeting.isInvite"
									dense
									rounded
									filled
									hide-details
									required
									@blur="checkChangeDetail"
									@focus="isChangeDetail = true"
								></v-textarea>
							</v-col>
							<v-col cols="12" sm="12" v-if="meeting.isInvite">
								<v-text-field
									v-model="meeting.extMeetingLink"
									label="External Meeting Link (Ex. Zoom, Teams)"
									:disabled="!meeting.isInvite"
									:rules="externalMeetingLinkRules"
									ref="externalMeetingLink"
									dense
									rounded
									filled
									required
									@blur="checkChangeDetail(meeting.extMeetingLink, true)"
									@focus="externalMeetingLinkStatus = 1; isChangeDetail = true"
								></v-text-field>
								<v-icon
									v-if="externalMeetingLinkStatus == 2"
									large
									color="green darken-2"
									style="position: absolute; right: 25px; bottom: 63px"
								>
									mdi-check-circle
								</v-icon>
								<v-icon
									v-else-if="externalMeetingLinkStatus == 1 || externalMeetingLinkStatus == 3"
									large
									color="red"
									style="position: absolute; right: 25px; bottom: 63px"
								>
									mdi-close-circle
								</v-icon>
							</v-col>
						</v-row>
					</v-card-text>
				</v-form>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import axios from "axios";

export default {
	props: {
		extData: {
			showDialog: false,
			tenantSlug: "",
			experienceSlug: ""
		},
		experience: null,
		networkingLounge:{}
	},
	data() {
		return {
			valid: false,
			appointmentList: [],
			eventList: [],
			weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			panelCalendar: 0,
			meeting: {
				date: null,
				startTime: null,
				endTime: null,
				tmpAttendee: [],
				attendeeList: [],
				title: null,
				message: null
			},
			startTime: [],
			endTime: [],
			showNewAppointmentDialog: false,
			showAppointmentDetailDialog: false,
			experienceUserList: [],
			baseLocation: axios.defaults.baseURL,
			isAnyAttendee: false,
			organizerName: this.$store.state.principal.firstName + " " + this.$store.state.principal.lastName,
			externalMeetingLinkRules: [
				(v) => ((v.startsWith('http://') || v.startsWith('https://')) || v == '') || 'Please enter the meeting url link starting with https:// or http://',
			],
			externalMeetingLinkStatus: 0,
			tmpMeeting: null,
			isChangeDetail: false
		};
	},
	mounted() {
		this.listAppointment();
		this.extData.isFristLoad = false;
	},
	methods: {
		loopData() {
			setTimeout(() => {
				if (this.$store.state.showNetworkingLounge) {
					this.loadData() ;
					this.loopData();
				}
			}, 10000);
		},
		initData() {
			this.valid = false;
			this.appointmentList = [];
			this.eventList = [];
			this.weekdays= ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
			this.panelCalendar = 0;
			this.meeting = {
				date: null,
				startTime: null,
				endTime: null,
				tmpAttendee: [],
				attendeeList: [],
				title: null,
				message: null
			};
			this.startTime = [];
			this.endTime = [];
			this.showNewAppointmentDialog = false;
			this.showAppointmentDetailDialog = false;
			this.experienceUserList = [];
			this.baseLocation = axios.defaults.baseURL;
			this.isAnyAttendee = false;
			this.organizerName = this.$store.state.principal.firstName + " " + this.$store.state.principal.lastName;
		},
		loadData() {
			axios
				.get("/system/appointment/find")
				.then((response) => {
					if (response.data) {
						let dataList = response.data;
						for (let event of this.eventList) {
							for (let hour of event.hourList) {
								if (hour.appointment) {
									let isFound = false;
									for (let data of dataList) {
										if (data.id === hour.appointment.id) {
											hour.appointment.title = data.title;
											hour.appointment.transitMap.status = data.transitMap.status;
											hour.appointment.extMeetingLink = data.extMeetingLink;

											let attendees = "";
											let length = data.attendeeList.length > 3 ? 3 : data.attendeeList.length;

											for (let i = 0; i < length; i++) {
												attendees += i == 0 ? "" : ", ";
												attendees += data.attendeeList[i].name;
											}
											hour.appointment.attendees = attendees
											isFound = true;
										}
									}
									if (!isFound) {
										hour.appointment = null;
									}
								} else {
									for (let item of dataList) {
										if (item.date === event.day) {
											this.addAppointment(hour, item);
										}
									}
								}
							}
						}
					}
				})
		},
		listAppointment() {
			this.appointmentList = {};
			this.eventList = [];
			let startDate = this.getDate(this.experience.startDate);
			let endDate = this.getDate(this.experience.endDate);

			var DifferenceInTime = endDate.getTime() - startDate.getTime();
			var DifferenceInDays = Math.floor(DifferenceInTime / (1000 * 3600 * 24));

			axios
				.get("/system/appointment/find")
				.then((response) => {
					this.initData();
					if (response.data) {
						this.appointmentList = response.data;

						for (let i = 0; i <= DifferenceInDays; i++) {
							let day = this.formatDate(startDate);

							let event = {
								day: day,
								hourList: this.listHourAppointment(day)
							};

							this.eventList.push(event);
							startDate.setDate(startDate.getDate() + 1);

							if (day === this.formatDate(new Date())) {
								this.panelCalendar = i;
							}
						}
					}
					this.loopData();
				})
				.catch(() => {});
		},
		listHourAppointment(day) {
			let hourList = [];
			for (let i = 0; i < 26; i++) {
				let sHour = 7 + (0.5 * i);
				let eHour = sHour + 0.5;

				let sName = this.formatTime(sHour);
				let eName = this.formatTime(eHour);

				let hour = {
					id: sHour,
					name: sName + (sHour < 13 ? "am" : "pm"),
					rangeName: sName + "-" + eName,
					start: sHour,
					end: eHour,
					appointment: null
				};

				for (let item of this.appointmentList) {
					if (item.date === day) {
						this.addAppointment(hour, item);
					}
				}

				hourList.push(hour);
			}
			return hourList;
		},
		addAppointment(hour, item) {
			item.startTime = item.startTime.replace(".0", "");
			item.endTime = item.endTime.replace(".0", "");

			let startTime = this.formatNumber(item.startTime);
			let endTime = this.formatNumber(item.endTime);

			if (startTime <= parseFloat(hour.start) && endTime >= parseFloat(hour.end)) {
				item.isInvite = item.creatorId == this.$store.state.principal.id;
				let attendees = "";
				let length = item.attendeeList.length > 3 ? 3 : item.attendeeList.length;

				let isAddAppointment = true;
				for (let i = 0; i < length; i++) {
					attendees += i == 0 ? "" : ", ";
					attendees += item.attendeeList[i].name;
					if (item.attendeeList[i].id === this.$store.state.principal.id) {
						isAddAppointment = !(item.attendeeList[i].status == 'Decline' || item.attendeeList[i].status == 'Declined' || item.attendeeList[i].status == 'Invite Sent')
						console.log(isAddAppointment)
					}
				}
				if (isAddAppointment) {
					item.attendees = attendees;
					hour.appointment = item;
				}
			}
		},
		showNewAppointment() {
			this.meeting = {
				date: null,
				startTime: null,
				endTime: null,
				tmpAttendee: [],
				attendeeList: [],
				title: null,
				message: null
			};

			this.startTime = [];
			this.endTime = [];
			this.showNewAppointmentDialog = true;
		},
		sendInvites() {
			axios
				.post("/system/meeting/add", {
					meeting: this.meeting
				})
				.then((response) => {
					if (response.data) {
						this.listAppointment();
						this.showNewAppointmentDialog = false;
					}
				})
				.catch(() => {});
		},
		editMeeting() {
			axios
				.post("/system/meeting/edit", {
					meeting: this.meeting
				})
				.then((response) => {
					if (response.data) {
						this.listAppointment();
						this.showAppointmentDetailDialog = false;
					}
				})
				.catch(() => {});
		},
		resendInvitation() {
			axios
				.post("/system/meeting/resendInvitation", {
					id: this.meeting.id
				})
				.then(() => {
					let notification = {
						title: "",
						content: {
							errorList: [],
							fieldErrorList: [],
							noticeList: ["Invitation successfully resent"],
							type: "NOTIFICATION"
						},
						withoutTitle: true
					};
					this.$store.commit("showNotification", notification);
				})
				.catch(() => {});
		},
		cancelMeeting(publicId, userId, id, isOganizer) {
			let url = "";
			if (isOganizer) {
				url = "/system/meeting/delete?id=" + id;
			} else {
				url = "/system/public/appointment/cancel?meetingId=" + publicId + "&attendeeId=" + userId;
			}

			axios
				.get(url)
				.then((response) => {
					if (response.data) {
						this.listAppointment();
						this.showAppointmentDetailDialog = false;
					}
				})
				.catch(() => {});
		},
		removeAttendee(index) {
			this.meeting.attendeeList.splice(index, 1);
			this.checkChangeDetail();
		},
		inviteAttendess() {
			for (let id of this.meeting.tmpAttendee) {
				for (let attendee of this.experienceUserList) {
					if (attendee.id == id) {
						attendee.status = "";
						this.meeting.attendeeList.push(attendee);
					}
				}
			}
			this.meeting.tmpAttendee = [];
			this.changeAttendee();
			this.checkChangeDetail();
		},
		changeAttendee() {
			this.isAnyAttendee = this.meeting.tmpAttendee.length > 0;
		},
		listAttendee() {
			this.experienceUserList = [];
			axios
				.post("/system/attendee/list", {
					date: this.meeting.date,
					startTime: this.meeting.startTime,
					endTime: this.meeting.endTime
				})
				.then((response) => {
					this.experienceUserList = response.data;
					for (let attendess of this.meeting.attendeeList) {
						for (var i = 0; i < this.experienceUserList.length; i++) {
							if (this.experienceUserList[i].email === attendess.email) {
								this.experienceUserList.splice(i, 1);
							}
						}
					}
				})
				.catch(() => {});
		},
		showAppointmentDetail(id) {
			axios
				.post("/system/meeting/find", { id: id })
				.then((response) => {
					if (response.data) {
						this.meeting = response.data;
						this.meeting.userPublicId = this.getUserPublicId();
						this.meeting.isInvite = this.meeting.creatorId == this.$store.state.principal.id;
						this.meeting.tmpAttendee = [];
						this.meeting.startTime = parseFloat(this.meeting.startTime.replace(".0", ""));
						this.meeting.endTime = parseFloat(this.meeting.endTime.replace(".0", ""));
						this.setStartTime(true);
						this.setEndTime(true);
						this.organizerName = this.meeting.transitMap.organizer;
						this.showAppointmentDetailDialog = true;
						if (!this.meeting.extMeetingLink) {
							this.externalMeetingLinkStatus = 0;
						}
						this.tmpMeeting = this.$root.clone(this.meeting);
						this.isChangeDetail = false;
					}
				})
				.catch(() => {});
		},
		getUserPublicId() {
			for (let attendee of this.meeting.attendeeList) {
				if (attendee.id == this.$store.state.principal.id) {
					return attendee.publicId;
				}
			}
			return null;
		},
		openConversation(appointment) {
			axios
				.post("/system/meeting/isReady", { id: appointment.id })
				.then((response) => {
					if (response.data) {
						if (appointment.extMeetingLink) {
							window.open(appointment.extMeetingLink, "_blank");
						} else {
							this.$store.commit('setShowNetworkingLounge', false);
							this.$router.push(
								"/" + this.$route.params.tenantSlug + "/" + this.$route.params.experienceSlug + "/passthrough/conversation/move/" + appointment.id
							);
						}
						this.extData.showDialog = false;
					} else {
						let notification = {
							title: "Conversation",
							content: {
								errorList: ["Please join between meeting start time and end time"],
								fieldErrorList: [],
								noticeList: [],
								type: "NOTIFICATION"
							}
						};
						this.$store.commit("showNotification", notification);
					}
				})
				.catch(() => {});
		},
		getDate(date) {
			return new Date(date.date.year, date.date.month - 1, date.date.day);
		},
		formatDate(date) {
			let options = {
				year: "numeric",
				month: "long",
				day: "numeric"
			};
			let formattedDate = date.toLocaleString("en-US", options).split(" ");
			let result =
				this.weekdays[date.getDay()] +
				" " +
				formattedDate[1].replace(",", "") +
				" " +
				formattedDate[0] +
				" " +
				formattedDate[2].replace(",", "");
			return result;
		},
		setStartTime(isDetail) {
			this.startTime = [];
			if (!isDetail) {
				this.meeting.startTime = null;
				this.meeting.endTime = null;
			}

			for (let i = 0; i < 26; i++) {
				let sHour = 7 + 0.5 * i;
				let eHour = sHour + 0.5;

				let sName = this.formatTime(sHour);

				let hour = {
					value: sHour,
					text: sName + (sHour < 12 ? "am" : "pm"),
					disabled: false
				};

				for (let item of this.appointmentList) {
					if (!isDetail || !item.isInvite) {
						if (item.date === this.meeting.date) {
							if (this.formatNumber(item.startTime) <= sHour && this.formatNumber(item.endTime) >= eHour) {
								hour.disabled = true;
							}
						}
					}
				}
				this.startTime.push(hour);
			}
		},
		setEndTime(isDetail = false) {
			this.endTime = [];
			if (!isDetail) {
				this.meeting.endTime = null;
			}

			for (let i = 0; i < 26; i++) {
				let sHour = 7.5 + 0.5 * i;
				let sName = this.formatTime(sHour);

				let hour = {
					value: sHour,
					text: sName + (sHour < 12 ? "am" : "pm"),
					disabled: false
				};

				if (this.formatNumber(this.meeting.startTime) >= sHour) {
					hour.disabled = true;
				}

				for (let item of this.appointmentList) {
					if (!isDetail || !item.isInvite) {
						if (item.date === this.meeting.date) {
							if (this.formatNumber(item.startTime) < sHour && this.formatNumber(item.endTime) >= sHour) {
								hour.disabled = true;
							}

							if (this.formatNumber(this.meeting.startTime) < this.formatNumber(item.startTime)) {
								if (this.formatNumber(item.endTime) < sHour) {
									hour.disabled = true;
								}
							}
						}
					}
				}
				this.endTime.push(hour);
			}
		},
		formatNumber(time) {
			time = time < 7 ? parseFloat(time) + 12 : time;
			return parseFloat(time.toString().replace(".3", ".5"));
		},
		formatTime(time) {
			time = time >= 13 ? time - 12 : time;
			return time.toString().replace(".5", ".30");
		},
		toProfile() {
			this.extData.showDialog = false;
			this.networkingLounge.showDialog = false;
			this.$store.commit('setShowNetworkingLounge', false);
			window.location = '/#/' + this.extData.tenantSlug + '/' + this.extData.experienceSlug + '/profile';
		},
		checkChangeDetail(link, isExtMeetingLink) {
			if (isExtMeetingLink) {
				this.ping(link);
			}
			this.isChangeDetail = false;
			let message = this.meeting.message ? this.meeting.message : "";
			let title = this.meeting.title ? this.meeting.title : "";
			let extMeetingLink = this.meeting.extMeetingLink ? this.meeting.extMeetingLink : "";

			let tmpMessage = this.tmpMeeting.message ? this.tmpMeeting.message : "";
			let tmpTitle = this.tmpMeeting.title ? this.tmpMeeting.title : "";
			let tmpExtMeetingLink = this.tmpMeeting.extMeetingLink ? this.tmpMeeting.extMeetingLink : "";

			if (message != tmpMessage || title != tmpTitle || extMeetingLink != tmpExtMeetingLink ||
				this.meeting.attendeeList.length != this.tmpMeeting.attendeeList.length) {
				this.isChangeDetail = true;
			}

			if (!this.isChangeDetail) {
				let attendeeIdList = [];
				for (let attendee of this.meeting.attendeeList) {
					attendeeIdList.push(attendee.id);
				}
				
				let tmpAttendeeIdList = [];
				for (let attendee of this.tmpMeeting.attendeeList) {
					tmpAttendeeIdList.push(attendee.id);
				}
				for (let id of tmpAttendeeIdList) {
					if (!attendeeIdList.includes(id)) {
						this.isChangeDetail = true;
						return;
					}
				}
			}
		},
		ping(link) {
			/*
				0 : External meeting link empty
				1 : Error startWiths validation
				2 : Link is active
				3 : Link is not active
			*/
			this.externalMeetingLinkStatus = 1;
			if (link) {
				this.meeting.extMeetingLink = link.trim();
				if (link.startsWith("http://") || link.startsWith("https://")) {
					axios
						.get("/system/public/url/ping?url=" + link)
						.then((response) => {
							if (response.data) {
								this.externalMeetingLinkStatus = 2;
							} else {
								this.externalMeetingLinkStatus = 3;
								this.$refs.externalMeetingLink.validate();
							}
						})
				}
			} else {
				this.externalMeetingLinkStatus = 0;
			}
		}
	}
};
</script>